module.exports = __webpack_public_path__ + "img/fondo-login.17c58751.jpg";